import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { GetBlogList, UpdateBlogStatus } from "../../Redux/Actions/blogActions";
import { columnsBlogList } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import BlogCategoryDropdown from "./dropDownBlog";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ListBlog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [categoryFilter, setCategoryFilter] = useState("");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
    const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

    const blogState = useSelector((state) => state.blog || {});
    const blogs = blogState.blogs || [];
    const blogTotal = blogState.total || 0;
    const { loading } = blogState;

    const fetchDetails = useCallback(
        (page = pagination.current, pageSize = pagination.pageSize) => {
            const payload = {
                page,
                limit: pageSize,
                ...(debouncedSearch && { filter: debouncedSearch }),
                ...(categoryFilter && { category: categoryFilter }),
                ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
                ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            };
            return dispatch(GetBlogList(payload)).catch(() => {
                toast.error("Failed to fetch blog list");
            });
        },
        [dispatch, debouncedSearch, categoryFilter, dateRange, pagination.current, pagination.pageSize]
    );

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize, fetchDetails]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, current: 1 }));
    }, [debouncedSearch, categoryFilter, dateRange]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, total: blogTotal }));
    }, [blogTotal]);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedSearch(searchQuery), 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (newPagination) => setPagination(newPagination);

    const handleDateRangeApply = (start, end) => {
        setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleStatusChange = async (record, action) => {
        let payload = { id: record._id };

        if (action === "primary") {
            payload.set_primary = true;
        } else if (action === "remove-primary") {
            payload.set_primary = false;
        } else {
            payload.status = action;
        }

        await dispatch(UpdateBlogStatus(payload));
        fetchDetails(pagination.current, pagination.pageSize);
    };

    return (
        <MainLayout>
            <div className="bookings_table">
                <div className="table_component_all">

                    {/* Top search bar */}
                    <div style={{ gridColumn: "span 5", height: "auto" }}>
                        <ListTopSearch
                            h3heading="Blogs List"
                            setState={setSearchQuery}
                            onCalendarClick={() => setIsDatePopupVisible(true)}
                        />
                        <div style={{ position: "absolute", marginTop: "-4.5%", marginLeft: "64%" }}>
                            {canAdd && (
                                <button
                                    style={{ background: "#070C18", color: "white", padding: "18px", borderRadius: "20px" }}
                                    onClick={() => navigate("/blog/add")}
                                >
                                    Add Blog
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Category dropdown — mirrors BookingSourceDropdown positioning in ListProjects */}
                    <div
                        style={{
                            position: "static",
                            marginTop: "-70px",
                            marginLeft: canAdd ? "90.5%" : "95%",
                            marginBottom: "24px",
                        }}
                    >
                        <BlogCategoryDropdown
                            value={categoryFilter}
                            onChange={(e) => setCategoryFilter(e.target.value)}
                        />
                    </div>

                    {/* Table */}
                    <div className="custom_table">
                        <div style={{ width: "90%" }}>
                            <Table
                                dataSource={Array.isArray(blogs) ? blogs : []}
                                virtual
                                scroll={{ x: 1700, y: 500 }}
                                pagination={pagination}
                                onChange={handleTableChange}
                                loading={loading}
                                columns={columnsBlogList(
                                    pagination.current,
                                    pagination.pageSize,
                                    fetchDetails,
                                    canEdit,
                                    handleStatusChange
                                )}
                                rowClassName={() => "text-center"}
                            />
                        </div>
                    </div>

                </div>
            </div>

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />
        </MainLayout>
    );
};

export default ListBlog;